export default __webpack_public_path__ + "static/lut-virusi-capsule-c67aaef994552f0454bad91fd381a6b3.png";